export default {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  }
};
